export default "__VITE_ASSET__092a9f6f__"